export const purchasingPaymentPaths = {
    purchasingPurchases: '/purchasing-payments/purchase',
    purchasingAdvances: '/purchasing-payments/advance',
    purchasingExpenses: '/purchasing-payments/expense',
    purchasingCreate: '/purchasing-payments/:type/new',
    purchasingDetail: '/purchasing-payments/requests/:paymentID',
} as const
